

        <div class="modal-content bg-body d-none d-sm-block rounded" style="height: 90vh !important;">
            <!-- <div class="modal-header w-100 p-2" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 1rem 1rem 0 0;">
                <h3 class="modal-title" class=" text-center"><strong> Log in</strong> </h3>
            </div> -->
            <button  style="position: absolute; top: 1%; right: 1%; z-index: 2;" (click)="modalRegistro()"  mat-raised-button color="primary"> Registrate</button>
            <button  matTooltip="SALIR"  style="position: absolute; top: 1%; left: 1%; z-index: 2;" (click)="cerrarmodal()"  mat-mini-fab color="primary"> 
                <mat-icon >reply</mat-icon>
            </button>
            <div class="modal-body">
                <div class="container-fluid" style="padding: 5% 5% 5% 5%;">
                    <div class="row">
                        <div class="col-md-6 col-sm-4 d-flex justify-content-end">
                            <img *ngIf="logo" class="mr-4" [src]="logo" style="aspect-ratio: 1/1; width:250px; height: 300px; object-fit: 100% 100%; margin-top: 20%;">
                        </div>
                        <div class="col-md-6 col-sm-8 d-flex justify-content-start ">
                            <div class="row">
                                <div class="col-md-9 text-center ">
                                    <h3 *ngIf="txt_l_3" class="fw-bold">{{txt_l_3}}</h3>
                                </div>
                                <div class="col-md-9">
                                    <div class="mat-elevation-z8 p-3 rounded ml-4">
                                        <form [formGroup]="forma" (ngSubmit)="login()" >
                                            <div class="row pb-2">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                                        <mat-label>Email</mat-label>
                                                        <input type="text" matInput    autocomplete="off" formControlName="nom_usuario">
                                                        <span mat-icon-button matSuffix >
                                                            <mat-icon >account_circle</mat-icon>
                                                         </span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row pb-2">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                                        <mat-label>Password</mat-label>
                                                        <input [type]="hide ? 'password' : 'text'" matInput    autocomplete="off" formControlName="pass_usuario">
                                                            <span mat-icon-button matSuffix [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                                               <mat-icon style="cursor: pointer;" (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                                            </span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row pb-2">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <button class="col-12 mb-2" mat-raised-button color="warn" type="submit"  [disabled]="forma.invalid"> Inciar Sesión</button>
                                                </div>  
                                            </div>
                                            <div class="row ">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <div (click)="recuperarPass()" class="text-black" style="cursor: pointer;"> <b> Olvidaste tu contraseña?</b></div>
                                                </div>
                                            </div>
                                        </form>
                                        <hr class="hr mx-3">
                                        <div class="row ">
                                            <div class="col-12 d-flex justify-content-center">
                                                <p>
                                                    <span>{{txt_l_1}}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-12 d-flex justify-content-center gap-3 mb-4">
                                                <button mat-raised-button color="basic"  class="rounded-pill">
                                                    <img class="mx-1    rounded-circle" src="../../../assets/img/buscar.png" style="width:20px; object-fit: 100% 100%;" alt="">
                                                    Google
                                               </button>
                                                <button mat-raised-button color="basic"  class="rounded-pill">
                                                    <img class="mx-1    rounded-circle" src="../../../assets/img/face.png" style="width:20px; object-fit: 100% 100%;" alt="">
                                                    Facebook
                                               </button>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-12 d-flex justify-content-center">
                                                    <span *ngIf="txt_l_2" class=" text-black-50 text-center" style="font-size: 9px;">{{txt_l_2}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="modal-footer p-2">
                                <button mat-button class="btn btn-danger mx-2" (click)="cerrarmodal()">Cancel</button>
                                <button mat-button type="submit" class=" btn btn-primary" (click)="login()" [disabled]="forma.invalid"> Accept</button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-content bg-body w-100 d-block d-sm-none ">
            <!-- <div class="modal-header w-100 p-2" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 1rem 1rem 0 0;">
                <h3 class="modal-title" class=" text-center"><strong> Log in</strong> </h3>
            </div> -->
           <!--  <button  style="position: absolute; top: 1%; right: 1%; z-index: 2;" (click)="modalRegistro()"  mat-raised-button color="primary"> Registrate</button> -->
            <button  matTooltip="SALIR"  style="position: absolute; top: 1%; left: 1%; z-index: 2;" (click)="cerrarmodal()"  mat-mini-fab color="primary"> 
                <mat-icon >reply</mat-icon>
            </button>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">
                            <img class="mr-4" [src]="logo" style="aspect-ratio: 1/1; width:100px; object-fit: 100% 100%; margin-top: 5%;">
                        </div>
                        <div class="col-12 d-flex justify-content-center ">
                            <div class="row">
                                <div class="col-12 text-center ">
                                    <h3 class="fw-bold">{{txt_l_3}}</h3>
                                </div>
                                <div class="col-12">
                                    <div class="mat-elevation-z8 p-3 rounded mb-5">
                                        <form [formGroup]="forma" (ngSubmit)="login()" >
                                            <div class="row pb-2">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                                        <mat-label>Email</mat-label>
                                                        <input type="text" matInput    autocomplete="off" formControlName="nom_usuario">
                                                        <span mat-icon-button matSuffix >
                                                            <mat-icon >account_circle</mat-icon>
                                                         </span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row pb-2">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <mat-form-field appearance="outline" class="w-100 mb-2">
                                                        <mat-label>Password</mat-label>
                                                        <input [type]="hide ? 'password' : 'text'" matInput    autocomplete="off" formControlName="pass_usuario">
                                                            <span mat-icon-button matSuffix [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                                               <mat-icon style="cursor: pointer;" (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                                            </span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="row pb-2">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <button class="col-12 mb-2" mat-raised-button color="warn" type="submit"  [disabled]="forma.invalid"> Inciar Sesión</button>
                                                </div>  
                                            </div>
                                            <div class="row ">
                                                <div class="col-12 d-flex justify-content-center">
                                                    <div (click)="recuperarPass()" class="text-black" style="cursor: pointer;"> <b> Olvidaste tu contraseña?</b></div>
                                                </div>
                                            </div>
                                        </form>
                                        <hr class="hr mx-3">
                                        <div class="row ">
                                            <div class="col-12 d-flex justify-content-center">
                                                <p>
                                                    <span>{{txt_l_1}}</span>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-12 d-flex justify-content-center gap-3 mb-4">
                                                <button mat-raised-button color="basic"  class="rounded-pill">
                                                    <img class="mx-1    rounded-circle" src="../../../assets/img/buscar.png" style="width:20px; object-fit: 100% 100%;" alt="">
                                                    Google
                                               </button>
                                                <button mat-raised-button color="basic"  class="rounded-pill">
                                                    <img class="mx-1    rounded-circle" src="../../../assets/img/face.png" style="width:20px; object-fit: 100% 100%;" alt="">
                                                    Facebook
                                               </button>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-12 d-flex justify-content-center">
                                                    <span class=" text-black-50 text-center" style="font-size: 9px;">{{txt_l_2}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="modal-footer p-2">
                                <button mat-button class="btn btn-danger mx-2" (click)="cerrarmodal()">Cancel</button>
                                <button mat-button type="submit" class=" btn btn-primary" (click)="login()" [disabled]="forma.invalid"> Accept</button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
